import { render, staticRenderFns } from "./ChartjsDoughnutChart5.vue?vue&type=template&id=00b629a3&"
import script from "./ChartjsDoughnutChart5.vue?vue&type=script&lang=js&"
export * from "./ChartjsDoughnutChart5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports